let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7VRye")).then(() => parcelRequire('hf4Jt'));